/* eslint-disable no-nested-ternary */
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  withGoogleMap,
  withScriptjs,
  GoogleMap,
  Marker,
} from 'react-google-maps';
import images from '_images';

const Map = withScriptjs(withGoogleMap(({ latLng, coordinate, location }) => {
  const { pathname } = location;

  const lat = (
    latLng
    && latLng.lat
  ) ? (
    (pathname.includes('help') || pathname.includes('details')) ? latLng.lat : latLng.lat - 0.0025
  ) : coordinate.lat;

  return (
    <GoogleMap
      zoom={16}
      center={{
        lat,
        lng: (latLng && latLng.lng) ? latLng.lng : coordinate.lng,
      }}
      defaultOptions={{
        disableDefaultUI: true
      }}
    >
      {
        latLng
          && latLng.lat
          && latLng.lng
          ? (
            <Marker
              icon={{ url: images.icons.marker }}
              position={{ lat: latLng.lat, lng: latLng.lng }}
            />
          )
          : null
      }
    </GoogleMap>
  );
}));

const mapStateToProps = (state) => ({
  coordinate: state.zone.coordinate,
});

export default withRouter(connect(mapStateToProps)(Map));
